import { getConfig } from "./runtimeConfig";

/**
 * API Configuration
 * 
 * Uses runtime config (loaded from /config.json at container startup) for API_BASE_URL.
 * Falls back to REACT_APP_GENERATED_BACKEND_URL build-time env var for local `npm start`.
 * 
 * NOTE: getConfig() is safe to call here because loadConfig() completes
 * before React renders (see index.js boot sequence).
 */
const apiConfig = {
    // Use runtime config first, fall back to build-time env var for local dev
    get API_BASE_URL() {
        return getConfig().API_BASE_URL;
    },
    // DMS base URL (e.g. http://localhost:8085/api)
    get DMS_BASE_URL() {
        return getConfig().DMS_BASE_URL;
    },
    // This function should point to the generated backend's data endpoint for a resource
    getResourceUrl: (resourceName: string) => {
        const base = getConfig().API_BASE_URL;
        return base + "/" + resourceName.toLowerCase();
    },
    // This function should point to the Designer Backend's metadata endpoint for a resource
    getResourceMetaDataUrl: (resourceName: string) => {
        const base = getConfig().API_BASE_URL;
        return base + "/getAllResourceMetaData/" + resourceName.toLowerCase();
    },
    // DMS document upload endpoint
    getDmsUploadUrl: () => {
        return getConfig().DMS_BASE_URL + "/documents/upload";
    },
    // DMS document download endpoint
    getDmsDownloadUrl: (fileId: string) => {
        return getConfig().DMS_BASE_URL + "/documents/" + fileId + "/download";
    },
};

export default apiConfig;